<template>
    <div class="flex-level">
        <div class="ellipsis search-result-item gray-100">
            <span>{{ data.subtype }}</span>
        </div>
        <div class="ellipsis search-result-item ml-2 gray-60">
            <span>{{ data.number }}</span>
            <span class="ml-2">{{ data.name }}</span>
        </div>

        <div v-if="data.link" class="flex-right"><i class="icon-chevron-right gray-60"></i></div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
.search-result-item:nth-child(2) {
    white-space: nowrap;
    max-width: 450px;
}
</style>
